import React from 'react';
import {useLocation} from 'react-router-dom';
import styled from 'styled-components';
import {useI18n} from '../../../../hooks';
import {
  AssetIconCreateEvent,
  AssetIconHome,
  AssetIconResetTime,
  AssetIconEmployees,
  AssetIconSettings,
} from '../../../../assets';
import {RootRoute} from '../../../../routes/RootRoute';
import {EmployeeSidebarItem} from './components/EmployeeSidebarItem';

interface EmployeeMenuItemsContainerProps {
  isCollapsed: boolean;
  onMenuClick?: () => void;
}

const StyledMenuItemsContainer = styled.div<{isCollapsed: boolean}>`
  padding-left: ${props => (props.isCollapsed ? undefined : '0%')};
`;

export const EmployeeMenuItemsContainer = ({
  isCollapsed,
  onMenuClick,
}: EmployeeMenuItemsContainerProps) => {
  const location = useLocation();
  const currentRoute = location.pathname; // Get the current route from URL
  const t = useI18n();

  return (
    <StyledMenuItemsContainer isCollapsed={isCollapsed}>
      <EmployeeSidebarItem
        title={t.navigation.home}
        to={RootRoute.EmployeeHome}
        icon={<AssetIconHome />}
        currentRoute={currentRoute}
        onClick={onMenuClick}
      />
      <EmployeeSidebarItem
        to={RootRoute.CreateHubbl}
        icon={<AssetIconCreateEvent />}
        title={t.navigation.createHubbl}
        currentRoute={currentRoute}
        onClick={onMenuClick}
      />
      <EmployeeSidebarItem
        to={RootRoute.ColleaguesOverview}
        icon={<AssetIconEmployees />}
        title={t.navigation.colleagues}
        currentRoute={currentRoute}
        onClick={onMenuClick}
      />
      <EmployeeSidebarItem
        to={RootRoute.EmployeePastEvents}
        icon={<AssetIconResetTime />}
        title={t.navigation.previousEvents}
        currentRoute={currentRoute}
        onClick={onMenuClick}
      />
      <EmployeeSidebarItem
        to={RootRoute.EmployeeSettings}
        icon={<AssetIconSettings />}
        title={t.navigation.settings}
        currentRoute={currentRoute}
        onClick={onMenuClick}
      />
    </StyledMenuItemsContainer>
  );
};
